import { PortalError } from './PortalError';

export class UpdateError extends PortalError {
  constructor() {
    super('UpdateError', 'Field was not updated correctly');
  }
}
